import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  linkText: string;
  linkUrl: string;
  delay?: number;
  imageUrl?: string;
}
export function TestimonialCard({
  quote,
  linkText,
  linkUrl,
  delay = 0,
  imageUrl
}: TestimonialCardProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (imageUrl) {
      setIsModalOpen(true);
    } else {
      window.location.href = linkUrl;
    }
  };
  return <>
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay,
      duration: 0.5
    }} whileHover={{
      y: -5
    }} className="relative flex flex-col rounded-2xl bg-white p-6 shadow-md border border-slate-200" data-id="element-18">
        {/* WhatsApp decoration */}
        <div className="absolute -top-3 -right-3 flex h-8 w-8 items-center justify-center rounded-full bg-green-500 text-white shadow-lg" data-id="element-19">
          <MessageCircle size={16} fill="currentColor" data-id="element-20" />
        </div>

        <div className="mb-4 flex-grow" data-id="element-21">
          <p className="text-slate-700 italic leading-relaxed" data-id="element-22">"{quote}"</p>
        </div>

        <button onClick={handleClick} className="mt-auto flex items-center gap-2 text-sm font-semibold text-green-600 hover:text-green-500 transition-colors" data-id="element-23">
          <span data-id="element-24">📲</span>
          <span className="underline decoration-green-600/30 underline-offset-4" data-id="element-25">
            {linkText}
          </span>
        </button>
      </motion.div>

      {/* Modal */}
      <AnimatePresence data-id="element-26">
        {isModalOpen && imageUrl && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setIsModalOpen(false)} className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4" data-id="element-27">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} onClick={e => e.stopPropagation()} className="relative max-w-2xl w-full bg-white rounded-2xl shadow-2xl overflow-hidden" data-id="element-28">
              {/* Close button */}
              <button onClick={() => setIsModalOpen(false)} className="absolute top-4 right-4 z-10 flex items-center justify-center w-10 h-10 rounded-full bg-slate-900/80 text-white hover:bg-slate-900 transition-colors" data-id="element-29">
                <X size={20} data-id="element-30" />
              </button>

              {/* Image */}
              <img src={imageUrl} alt="Conversación de WhatsApp" className="w-full h-auto" data-id="element-31" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}